import { createFileRoute } from '@tanstack/react-router'

import { RunsPage } from '#/modules/ai/back-office/runs-page/runs-page.tsx'
import { requirePermissions } from '#/shared/routing/require-permissions.ts'

export const Route = createFileRoute('/bo/ai/runs/')({
  beforeLoad: ({ context }) => requirePermissions(context, ['aiAnalysis.review.read']),
  component: function Component() {
    return <RunsPage />
  },
})
